/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TbaConfigResponseDto
 */
export interface TbaConfigResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TbaConfigResponseDto
     */
    tbaBrokerIDs: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TbaConfigResponseDto
     */
    tbaReinsuredIDs: Array<string>;
}

/**
 * Check if a given object implements the TbaConfigResponseDto interface.
 */
export function instanceOfTbaConfigResponseDto(value: object): value is TbaConfigResponseDto {
    if (!('tbaBrokerIDs' in value) || value['tbaBrokerIDs'] === undefined) return false;
    if (!('tbaReinsuredIDs' in value) || value['tbaReinsuredIDs'] === undefined) return false;
    return true;
}

export function TbaConfigResponseDtoFromJSON(json: any): TbaConfigResponseDto {
    return TbaConfigResponseDtoFromJSONTyped(json, false);
}

export function TbaConfigResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TbaConfigResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tbaBrokerIDs': json['tbaBrokerIDs'],
        'tbaReinsuredIDs': json['tbaReinsuredIDs'],
    };
}

export function TbaConfigResponseDtoToJSON(json: any): TbaConfigResponseDto {
    return TbaConfigResponseDtoToJSONTyped(json, false);
}

export function TbaConfigResponseDtoToJSONTyped(value?: TbaConfigResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tbaBrokerIDs': value['tbaBrokerIDs'],
        'tbaReinsuredIDs': value['tbaReinsuredIDs'],
    };
}

